import {PageContent} from '@/i18n/model/en/page-content/page-content'

export const en = {
  pageContent: PageContent,
}
